/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Cta_TitleInputs */

const en_directory_ai_tools_cta_title = /** @type {(inputs: Directory_Ai_Tools_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make your video now`)
};

const zh_directory_ai_tools_cta_title = /** @type {(inputs: Directory_Ai_Tools_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`现在就做你的视频`)
};

/**
* | output |
* | --- |
* | "Make your video now" |
*
* @param {Directory_Ai_Tools_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_cta_title = /** @type {((inputs?: Directory_Ai_Tools_Cta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Cta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_cta_title(inputs)
	return zh_directory_ai_tools_cta_title(inputs)
});
export { directory_ai_tools_cta_title as "directory.ai_tools.cta_title" }